import React, { useEffect, useState } from 'react';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moStore, { toggleValue } from '@store/index';
import moLogin, { toggleLogin } from '@store/login';
import moIndex, { initIndex } from '../store/index';
import moResearch, { initIndustryResearch } from './store/index';
import IndustryChain from './industry-chain/index';
import moIndustryChain, { initIndustryChain } from './industry-chain/store';
import TypicalPosition from './typical-position/index';
import moTypicalPosition, { initTypicalPosition } from './typical-position/store';
import CompanyDistribution from './company-distribution/index';
import moCompanyDistribution from './company-distribution/store';
import CompanyScale from './company-scale/index';
import moCompanyScale from './company-scale/store';
import IndustryReport from './industry-report/index';
import moIndustryReport, { initIndustryReport } from './industry-report/store';
import Head from '../component/head';
import MarketScale from './market-scale/index';
import moMarketScale from './market-scale/store';
import AddContactModal from '@comp/add-contact-modal/index';
import AddReportModal from '@comp/add-report-modal/index'
import { newUrl } from '@/tool';


interface IProps {}
interface IState {}

// 行业研究
const IndustryResearch = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { id } = useParams();
  const {industry} = moIndex
  const [searchParams] = useSearchParams();
  const industryCode = searchParams.get('industryCode');
  const categoryName = searchParams.get('categoryName');
  useEffect(() => {
    newUrl({title:'人力核心指标_行业研究',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'], navi)
  }, []);
  useEffect(() => {

    toggleLogin(false);
    if (id === '1') {
      // 行业概览
      const distance1 = document.getElementById('research1')?.offsetTop || 325;
      window.scrollTo(0, distance1 + 40);
    } else if (id === '2') {
      // 行业研报
      const distance2 = document.getElementById('research2')?.offsetTop || 325;
      window.scrollTo(0, distance2 + 50);
    } else { // 默认 id === '0'
      // 当id为0时，跳转到页面顶部

      window.scrollTo(0, 0);
    }

    return () => {};
  }, [document.title]);

  return (
    <section id="research1" className="industry-research_10">
      <Head title="行业概览" bigTitle="行业研究" />
      <IndustryChain />
      <TypicalPosition />
      {/* <MarketScale /> */}
      <CompanyDistribution />
      <CompanyScale />
      <IndustryReport />
      <AddContactModal />
      <AddReportModal />
    </section>
  );
};

export default observer(IndustryResearch);
